import { Icon } from "@synergy/icons";
import { Col, Flex, Row } from "antd";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import logger from "../../../../server/server";
import { Field, PageContent } from "../../../../styles/global/Pages.styled";
import { toKebabCase, toPascalCase, toTitleCase } from "../../../../utils/hooks/stringSerialization";
import Spinner from "../../Atomics/Spinner";
import { Text } from "../../Atomics/Text";
import { RegisterMapComponent } from "../../Organism/Maps/RegisterMapComponent";

const MapWrapper = styled.div`
  height: 200px;
`;

export const ItemDetail = ({ item, ...props }) => {
    // Obtém a função de tradução do hook useTranslation para uso na tradução de textos
    const { t } = useTranslation();
    const [showMore, setShowMore] = useState(false); //State para mostrar mais ou menos dados do Item
    const [filteredItem, setFilteredItem] = useState();
    useEffect(() => {
        logger.info("User entered ItemDetail successfully!");
    }, []);

    useEffect(() => {
        if (item) {
            const keysToKeep = [
                "name",
                "Address",
                "location",
                // "type",
                // "family",
                "class",
                "latitude",
                "longitude",
            ];
            const filtered = Object.keys(item)
                .filter((key) => keysToKeep.includes(key))
                .sort((a, b) => keysToKeep.indexOf(a) - keysToKeep.indexOf(b))
                .reduce((obj, key) => {
                    const pascalCaseKey = toPascalCase(key);
                    obj[pascalCaseKey] = item[key];
                    return obj;
                }, {});

            setFilteredItem(filtered);
        }
    }, [item]);

    return (
        <PageContent className={clsx('building_room_details', props?.className)}>
            {filteredItem ? (
                <Row gutter={[16, 16]}>
                    <Col span={24} style={{ alignContent: 'center' }}>
                        <Row>
                            <Col span={10}>
                                <h3>
                                    {item?.name} | {t("Overview").toLocaleUpperCase()}
                                </h3>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        {item ?
                            <Row gutter={[16, 16]}>
                                <Col span={16}>
                                    <Row gutter={[16, 16]}>
                                        {Object.keys(filteredItem)?.map((key, index) => {
                                            if (index < 6) {
                                                return (
                                                    <Col span={12} key={index} className='d-flex'>
                                                        <Field id={index} $backgroundColor="neutral-3" className='full-width'>
                                                            <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{t('input.' + toKebabCase(key))}</Text>
                                                            <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular'>{filteredItem[key] && filteredItem[key] != '' ? t(filteredItem[key]) : '-'}</Text>
                                                        </Field>
                                                    </Col>
                                                )
                                            }
                                        })}
                                        {Object.keys(filteredItem)?.length > 7 ?
                                            <Col span={24} >
                                                <Flex align="center" justify="center">
                                                    <Flex align="center" justify="center" onClick={() => setShowMore(!showMore)} style={{ cursor: 'pointer' }}>
                                                        <Text $fontColor='blue-4' $fontSize='text_md' $weight='medium' $marginRight="s03">{showMore ? t('seeLess') : t('seeMore')}</Text>
                                                        <Icon icon={showMore ? 'ChevronUp' : 'ChevronDown'} iconsize='sm' color='blue-4' />
                                                    </Flex>
                                                </Flex>
                                            </Col> : null
                                        }
                                    </Row>
                                </Col>
                                <Col span={8}>
                                    <Flex gap={16} vertical="true">
                                        <MapWrapper>
                                            <RegisterMapComponent item={[item]} idQuery='RegisterDetail' idCenter={{ lat: parseFloat(item?.latitude), lng: parseFloat(item?.longitude) }} idZoom={17} mapId={'e1816747e3cd86e6'} configId={'registerDetail'} disableClick={true} />
                                        </MapWrapper>
                                    </Flex>
                                </Col>
                                {showMore ?
                                    Object.keys(filteredItem)?.map((key, index) => {
                                        if (index > 5 && key !== 'iconBase64') {
                                            return (
                                                <Col span={8} key={index} className='d-flex'>
                                                    <Field id={index} $backgroundColor="neutral-3" className='full-width'>
                                                        <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{t('input.' + toKebabCase(key))}</Text>
                                                        <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular'>{filteredItem[key] && filteredItem[key] != '' ? t(filteredItem[key]) : '-'}</Text>
                                                    </Field>
                                                </Col>
                                            )
                                        }
                                    })
                                    : null
                                }
                            </Row>
                            : null}
                    </Col>
                </Row>
            ) : (
                <div style={{ height: 'inherit', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <Spinner stroke="green" />
                </div>
            )
            }
        </PageContent >
    )
};